import type { WebsiteHeaderPhotoSchema_VideoBackgroundMonogram } from '@shared/types/WebsiteHeaderSettings.types';

export const VIDEO_BACKGROUND_MONOGRAM_DEFAULT: WebsiteHeaderPhotoSchema_VideoBackgroundMonogram = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackgroundMonogram-v1_0_0.json',
  presentationLayout: 'videoBackgroundMonogram',
  video: undefined,
  jsonContainerId: null,
  colors: undefined,
};
